import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Modal,
    Card,
    CardContent,
    CardActions,
    Grid,
    CardHeader,
    Divider,
    Table,
    TableCell,
    TableRow,
    TableHead,
    Typography,
    Select,
    MenuItem,
    TextField,
    Switch,
    Button,
    colors
} from '@material-ui/core';
import { edit_admin, edit_admin_property, get_admin_details } from '../../api/API';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%'
    },

    container: {
        marginTop: theme.spacing(3)
    },

    actions: {
        justifyContent: 'flex-end'
    },

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    },

    leftIcon: {
        marginRight: theme.spacing.unit,
    },

}));

export default function EditAdmin(props) {

    const { open, onClose, customer, className, ...rest } = props;

    const classes = useStyles();
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [formState, setFormState] = useState({
        ...props.admins,
        password: "",
    });
    const [properties, setProperties] = useState([]);
    const get_data = async () => {
        const postparam = {
            admin_id: props.admins.admin_id
        };

        var json = await get_admin_details(postparam);
        if (json.status) {
            console.log(json.data.property);
            setProperties(json.data.property);
        }
    }


    const handleSubmit = async (event) => {
        var property_val = {
            "admin_id": props.admins.admin_id
        };
        for (var i = 0; i < properties.length; i++) {
            property_val['property_' + properties[i].property_id] = parseInt(properties[i]['can_edit']) > 0 ? "true" : "false";
        }

        
        let data = await edit_admin({
            ...formState,
            password: password,
            password2: password2
        });
        let data2 = await edit_admin_property(property_val);
        if (data && data2) {
            onClose();
        }
    };
    const handleFieldChange = event => {
        event.persist();
        if (event.target.name == 'password') {
            setPassword(event.target.value);
            return;
        }
        else if (event.target.name == 'password2') {
            setPassword2(event.target.value);
            return;
        }
        setFormState(formState => ({
            ...formState,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        }));
    };

    const handlePropertyChange = event => {
        var prop = [...properties];

        for (var i = 0; i < prop.length; i++) {
            if (prop[i].property_id == event.target.name) {
                prop[i]['can_edit'] = event.target.checked ? 1 : 0;
            }
        }

        setProperties(prop);
    };
    useEffect(() => {
        get_data();
        setFormState(props.admins);
    }, []);

    return (
        <Modal
            onClose={onClose}
            open={open}
        >
            <Card
                {...rest}
                className={" edit_modal"}
            >
                <CardHeader
                    //   action={<GenericMoreButton />}
                    title="Edit Admin Detail"
                />
                <Divider />
                <form>
                    <CardContent>

                        <Grid
                            className={classes.container}
                            container
                            spacing={3}
                        >
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Name"
                                    name="name"
                                    onChange={handleFieldChange}
                                    value={formState.name}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    onChange={handleFieldChange}
                                    value={formState.email}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Contact Number"
                                    name="contact"
                                    onChange={handleFieldChange}
                                    value={formState.contact}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Password *Leave blank if not changing"
                                    name="password"
                                    onChange={handleFieldChange}
                                    type="password"
                                    value={password}
                                    placeholder="Leave blank if not changing"
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Confirm Password"
                                    name="password2"
                                    value={password2}
                                    onChange={handleFieldChange}
                                    type="password"

                                    variant="outlined"
                                />
                            </Grid>


                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <Select
                                    fullWidth
                                    name="role_id"
                                    value={formState.role_id}
                                    variant="outlined"
                                    onChange={handleFieldChange}
                                >
                                    <MenuItem value="1">Superadmin</MenuItem>
                                    <MenuItem value="2">Admin</MenuItem>
                                </Select>
                            </Grid>


                        </Grid>
                        <br></br>
                        <hr></hr>
                        <br></br>
                        {formState.role_id == "2" ?
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Showroom Name</TableCell>
                                        <TableCell>Can Edit</TableCell>
                                    </TableRow>
                                </TableHead>
                                {properties.map((property) => (
                                    <TableRow>
                                        <TableCell>{property.name}</TableCell>
                                        <TableCell>
                                            <Switch
                                                checked={parseInt(property.can_edit) > 0}
                                                color="primary"
                                                onChange={handlePropertyChange}
                                                name={property.property_id}
                                            ></Switch>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </Table> : ""}
                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Button
                            style={{
                                backgroundColor: "black"
                            }}
                            onClick={onClose}
                            variant="contained"
                        >
                            <CloseIcon className={classes.leftIcon} />
                            Close
                    </Button>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                        >
                            <SaveIcon className={classes.leftIcon} />
                            Save
                    </Button>
                    </CardActions>
                </form>
            </Card>
        </Modal>
    )
}
